defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ChooseRows',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Utils',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/ChooseRows',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubPage'
  ],
  function (Component, PlayTogetherDictionary, NumberGamesUtils, Params, ChooseRows, CardFlowHeader, ClubPage) {

    // Component:
    Component('choose-rows', [PlayTogetherDictionary], function (m, route, settings, property) {
      // Components:
      var root = {
        controller: function () {
          this.property = property;
          this.settings = settings;
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'ChooseRows/' });

          this.clubPageClassName = m.prop('choose-rows-section');
          this.gameType = m.prop(Params.extract('gameType'));
          if (!this.gameType()) {
            window.history.back();
          }
        },

        view: function (controller) {
          var subtitle = function () {
            var subtitleWithoutJackpotFeed = controller.dictionary('Subtitle/' + NumberGamesUtils.formatNaming(controller.gameType(), 'capitalized') + 'WithoutJackpot');
            var jackpots = controller.settings.jackpots;
            if (jackpots && jackpots[controller.gameType()]) {
              var dictionaryJackpot = {};
              dictionaryJackpot[controller.gameType()] = jackpots[controller.gameType()];
              return controller.dictionary('Subtitle/' + NumberGamesUtils.formatNaming(controller.gameType(), 'capitalized'), dictionaryJackpot);
            }
            if (subtitleWithoutJackpotFeed && subtitleWithoutJackpotFeed.length > 0) {
              return subtitleWithoutJackpotFeed;
            }
            return null;
          };

          return m(ClubPage, { controller }, {
            flowHeader: CardFlowHeader({
              goBack: () => {
                window.history.back();
              }
            }),
            title: controller.dictionary('PageTitle'),
            description: subtitle(),
            content: ChooseRows,
            hideTopButtons: true,
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
